import styled from "@emotion/styled";
import { Typography } from "@avenue-8/sidekick-ui";

export const Row = styled.div`
  display: flex;
  align-items: stretch;
  gap: 0.75rem;
  margin-left: auto;

  ${(p) => p.theme.media.mobileDown} {
    margin-left: 0;
    flex-wrap: wrap;
  }
`;

export const Pill = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border: 1px solid ${(p) => p.theme.colors.border2};
  border-radius: 0.5rem;

  ${(p) => p.theme.media.mobileDown} {
    padding: 0.5rem 1rem;
    flex: 1;
    min-height: 3rem;
  }
`;

export const FilterPill = styled(Pill)`
  ${(p) => p.theme.media.mobileDown} {
    flex-basis: 100%;
  }
`;

export const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors.background5};
  color: ${(p) => p.theme.text.colors.brand};
  flex-shrink: 0;
`;

export const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CountLabel = styled(Typography)`
  font-size: ${(p) => p.theme.text.fontSizes.s};
  line-height: 1.2;
`;

export const CountSubLabel = styled(Typography)`
  font-size: ${(p) => p.theme.text.fontSizes.xs};
  line-height: 1.2;
  color: ${(p) => p.theme.text.colors.secondary};
`;

export const CheckboxLabel = styled(Typography)`
  font-size: ${(p) => p.theme.text.fontSizes.s};
`;
